// App Routes
import { Routes } from "@angular/router";
import { redirectGuard } from "@core/guards/redirect/redirect.guard";
import { ProxyComponent } from "@core/components/proxy/proxy.component";
import { APP_ROUTES } from "@core/constants/auth-constants";

// Public (unauthenticated) routes only; protected ones are loaded dynamically.
export const routes: Routes = [
  {
    path: APP_ROUTES.LOGIN.substring(1),
    canActivate: [redirectGuard],
    loadComponent: () => import('@features/auth/components/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: APP_ROUTES.SIGNUP.substring(1),
    canActivate: [redirectGuard],
    loadComponent: () => import('@features/auth/components/signup/signup.component').then(m => m.SignupComponent),
  },
  {
    path: APP_ROUTES.RESET_PASSWORD.substring(1),
    canActivate: [redirectGuard],
    loadComponent: () => import('@features/auth/components/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  { path: APP_ROUTES.PROXY.substring(1), canActivate: [redirectGuard], component: ProxyComponent },
  {
    path: APP_ROUTES.CALLBACK.substring(1),
    canActivate: [redirectGuard],
    loadComponent: () => import('@core/components/callback/callback.component').then(m => m.CallbackComponent),
  },
  { path: '**', redirectTo: APP_ROUTES.LOGIN.substring(1) },
];
